import React from "react";
import { Container, Row, Col, CardBody, Card } from "reactstrap";
import { Link } from "react-router-dom";
import { designPricing } from "./DummyData";
import "../../sass/design.scss";
import FAQAccordion from "../../../components/FAQAccordion";
import TextSlicer from "../../../components/TextSlicer";
import MetaData from "../../../components/MetaData";
import GoogleReviewSection from "../../../components/GoogleReviewSection";

const graphicDesignExpertise = [
  "SoftoRithm Technologies has 10+ years of experience in providing quality web designing services.",
  "We have been involved in countless projects where our team of specialists has been challenged and successfully delivered results.",
  "Our team conducts detailed discussions with clients to understand their vision.",
  "After understanding the requirements, we proceed with the work to deliver satisfactory results in record time.",
];

const uiUxExpertise = [
  "User Interface (UI) and User Experience (UX) are the two key components of website design.",
  "As professional website designers, we focus on creating creative and user-friendly designs for your audience.",
  "Visitors should be able to navigate the website easily without any confusion.",
  "Websites must be responsive and fast across all devices.",
  "Color scheme, layout, and scalability are optimized for laptops, tablets, and mobile devices.",
  "Our experts focus on maintaining perfect harmony between UI and UX for the best digital experience.",
];

const designBenefits = [
  "Makes a powerful and impactful impression",
  "Increases the confidence and credibility of a brand",
  "Enhances user interaction and enjoyment",
  "Guarantees expert and consistent branding",
  "Increases sales and conversion rates",
  "Optimizes the accessibility and usability of websites",
  "Enhances internet exposure and SEO",
  "Saves time and lowers expenses over time",
];

const summary = `Softorithm's comprehensive design services combine creative excellence with strategic thinking to deliver visual solutions that not only look exceptional but also drive business results and enhance your brand's market position.`;

const Design = () => {
  const handleButtonClick = () => {
    // Handle button click - you can navigate to a specific page or perform any action
    console.log("See Our Work button clicked");
  };

  return (
    <div className="design">
      <MetaData
        metaTitle={"Design"}
        metaDescription={
          "At Softorithm, we pride ourselves on providing exceptional web development, graphic design, UI/UX design, and digital marketing services through our team of passionate professionals."
        }
      />

      {/* Section 1 - Hero with Google Review */}
      <GoogleReviewSection
        title="Web Design Services"
        subtitle="Professional graphic design and UI/UX services that transform your brand identity and create memorable user experiences. Trusted by businesses worldwide for over 12 years."
        buttonText="See Our Work"
        onButtonClick={handleButtonClick}
        companyName="Softorithm"
      />

      <div className="page_body">
        <div className=" mt-5">
          <Row className="justify-content-center">
            <Col lg={12}>
              <div className="text-center mb-4 pb-2 about_rgt_cont">
                <h4 className="fw-semibold fs-22 mb-4">
                  The Best Website Design Is A Must To Maximize <br></br> Your Customer’s
                  Digital Experience!
                </h4>
                <TextSlicer
                  text={`A Website is the online identity for businesses in the digital era. A website is what we would like to call the modern business card. Businesses use their website to market their products and services. As you know, every business wants to keep its identity prominent and attractive at the same time but it is not as easy as it seems. It’s best to work with the experienced web designers at SoftoRithm Technologies to enhance the user experience with high-quality graphics and a user-friendly design..
              `}
                />
              </div>
            </Col>
          </Row>
          <Row className="justify-content-center">
            <Col xl={9}>
              <Row className="justify-content-center">
                {(designPricing || []).map((price2, key) => (
                  <Col md={6} lg={4} xl={4} key={key}>
                    <Card className="pricing-box ribbon-box right">
                      <CardBody className="p-4 m-2">
                        <div className="d-flex align-items-start">
                          <div className="flex-grow-1 me-3">
                            <h5 className="mb-1 fw-semibold">{price2.type}</h5>
                            <p className="text-muted mb-0">{price2.purpose}</p>
                          </div>
                          <div className="avatar-sm flex-shrink-0">
                            <div className="avatar-title bg-light rounded-circle text-primary">
                              <i className={"fs-20 " + price2.icon}></i>
                            </div>
                          </div>
                        </div>

                        <hr className="my-4 text-muted" />
                        <div className="scrollable-list">
                          <ul className="list-unstyled text-muted vstack gap-3">
                            {(price2.points || []).map((point, key) => (
                              <li key={key}>
                                <div className="d-flex">
                                  <div className="flex-shrink-0 text-success me-1">
                                    <i className="ri-checkbox-circle-fill fs-15 align-middle"></i>
                                  </div>
                                  <div className="flex-grow-1">{point}</div>
                                </div>
                              </li>
                            ))}
                          </ul>
                        </div>
                        <div className="mt-3 pt-2">
                          <Link
                            to="/contact-us"
                            className={`btn btn-success w-100`}
                          >
                            Get Quote
                          </Link>
                        </div>
                      </CardBody>
                    </Card>
                  </Col>
                ))}
              </Row>
            </Col>
          </Row>

          {/* Section 7 - CTA Section */}
          <section className="erp_cta_section">
            <Container>
              <Row className="align-items-center">
                <Col lg={8} md={7} sm={12} className="mb-3 mb-md-0">
                  <p className="erp_cta_text">
                    Want to explore our services in the area of web designing?
                  </p>
                </Col>
                <Col lg={4} md={5} sm={12} className="text-center text-md-start">
                  <button
                    type="button"
                    className="erp_cta_btn"
                    onClick={handleButtonClick}
                  >
                    Call Us Today!
                  </button>
                </Col>
              </Row>
            </Container>
          </section>

          <div className="container mt-5">
            <div
              className="faq_section py-3"
              style={{ backgroundColor: "var(--body-bg-color, #f8f9fa)" }}
            >
              <Container>
                <Row className="justify-content-center">
                  <Col lg={12}>
                    <div className="faq_header text-center mb-5">
                      <h2 className="mb-3">
                        Frequently Asked Questions
                      </h2>
                    </div>
                    <FAQAccordion
                      faqData={[
                        {
                          question:
                            "How can our web design services elevate the visual identity of your brand or business?",
                          points: graphicDesignExpertise,
                        },
                        {
                          question:
                            "How do SoftoRithm Technologies’ UI/UX solutions create better digital experiences?",
                          points: uiUxExpertise,
                        },
                        {
                          question:
                            "What type of key benefits you get after investing in our professional design services for your website?",
                          points: designBenefits,
                        },
                      ]}
                    />
                  </Col>
                </Row>
              </Container>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Design;
